import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toaster } from "react-hot-toast";
import "./App.css";
import AdminLayout from "./layouts/admin";
import AuthLayout from "./layouts/auth";
import { checkEvent, setLocaleLanguage } from "@mainaction";
import LocaleStrings from "@language";

const App = (props) => {
  let { routes, session, localeLanguage } = props;
  useEffect(() => {
    var hostname = window.location.hostname;
    var seocode = hostname.split(".")[0];
    //var seocode = "carlaundry";
    props.checkEvent(session, seocode, (res) => {});
  }, []);

  useEffect(() => {
    //var userLang = LocaleStrings.getLanguage();
    console.log({ localeLanguage });
    LocaleStrings.setLanguage(localeLanguage);
  }, [localeLanguage]);
  return (
    <div className="App h-screen overflow-hidden">
      <Routes>
        <Route path="/*" element={<AdminLayout />} />
        <Route path="/auth/*" element={<AuthLayout />} />
      </Routes>

      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },

          // Default options for specific types
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    localeLanguage: state.localeLanguage,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ checkEvent, setLocaleLanguage }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
